<template>
  <ItemPage
    title="Material"
    size="sm"
    :actions="actions"
  >
    <h2 class="mb-6">
      Status: <span style="color: green"> {{ statusName(material.status) }} </span>
    </h2>

    <div class="white">
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Capa do material
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openUrl(material.cover_path)"
          >
            <v-icon left>
              mdi-cloud
            </v-icon> abrir capa
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        class="mt-10 mb-10"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Material
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openUrl(material.path)"
          >
            <v-icon left>
              mdi-cloud
            </v-icon> Abrir Material
          </v-btn>
        </v-col>
      </v-row>
      <v-form
        ref="form"
      >
        <v-row>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="material.type"
              :items="types"
              item-text="name"
              item-value="id"
              label="Tipo"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="material.teaching_system_id"
              :items="systems"
              item-text="name"
              item-value="id"
              label="Sistemas de ensino"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="material.publishing_year"
              :error-messages="formErrors.publishing_year"
              :items="years"
              :disabled="subjectTextBooksUpdate"
              label="Ano de publicação"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            class="mr-auto"
          >
            <v-select
              v-model="material.grade_level_group_id"
              :items="gradelevelGroups"
              :error-messages="formErrors.grade_level_group_id || formErrors.grade_level_id"
              item-text="name"
              item-value="id"
              label="Segmento"
              hide-details="auto"
              outlined
              @change="getGradeLevel"
            />
          </v-col>
          <v-col
            v-if="!hideGradeLevelField"
            class="mr-auto"
          >
            <v-select
              v-model="material.grade_level_id"
              :items="gradelevels"
              :error-messages="formErrors.grade_level_id"
              item-text="name"
              item-value="id"
              label="Ano"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            v-if="!hideSubjectField"
            cols="12"
            class="mr-auto"
          >
            <v-select
              v-model="material.subject_id"
              :error-messages="formErrors.subject_id"
              :items="subjects"
              item-text="name"
              item-value="id"
              label="Matéria"
              placeholder="Escolha uma matéria"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            v-if="enableName"
            cols="12"
            class="mr-auto"
          >
            <v-text-field
              v-model="material.name"
              :error-messages="formErrors.name"
              :disabled="subjectTextBooksUpdate"
              label="Nome do material"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            v-if="!hideVolumeField"
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="material.volume_id"
              :items="volumes"
              :error-messages="formErrors.volume_id"
              item-text="name"
              item-value="id"
              label="Volume"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-text-field
              v-model="material.order"
              :disabled="subjectTextBooksUpdate"
              label="Ordem"
              type="number"
              hide-details="auto"
              outlined
            />
            <span style="font-size: 12px; color: blue"> Preencher ordem com ( -1 ) para materiais paradidaticos</span>
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            Material do professor
            <v-switch
              v-model="material.is_teacher_material"
              class="ma-2"
              :label="material.is_teacher_material ? 'Sim' : 'Não'"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            Material publicado
            <v-switch
              v-model="material.is_published"
              class="ma-2"
              :label="material.is_published ? 'Sim' : 'Não'"
              hide-details="auto"
              outlined
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            Publicar material quando atualizar
            <v-switch
              v-model="material.should_publish_after_processing"
              class="ma-2"
              :label="material.should_publish_after_processing ? 'Sim' : 'Não'"
              hide-details="auto"
              outlined
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
  </ItemPage>
</template>

<script>
import utils from '@/api/utils.js'
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { types as materialTypes, listTypes } from '@/enums/materialTypes'
import { listTypes as listVolumeTypes } from '@/enums/volumeTypes'
import { getTextForDisplay as statusName } from '@/enums/materialStatus'

export default {
  components: {
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],
  data () {
    return {
      subjectTextBooksUpdate: false,
      subjectTextBooksDelete: false,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.',
        value => (value && value.length >= 3) || 'Min 3 caracteres'
      ],
      years: [
        new Date().getFullYear() + 1,
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3
      ],
      systems: [],
      subjects: [],
      material: {},
      formError: {},
      gradelevelGroups: [],
      gradelevels: [],
      types: [],
      volumes: [],
      hideVolumeField: false,
      hideSubjectField: false,
      hideGradeLevelField: false
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Atualizar',
          action: this.updateMaterial,
          icon: 'mdi-floppy',
          disabled: this.subjectTextBooksUpdate
        },
        {
          label: 'Deletar',
          action: this.deleteMaterial,
          icon: 'mdi-delete',
          disabled: !this.subjectTextBooksDelete
        }
      ]
    },
    id () {
      return this.$route.params.id
    },
    enableName () {
      if (this.hideSubjectField) {
        return true
      }
      if (this.material?.subject_id) {
        return false
      }
      return true
    }
  },
  watch: {
    'material.type' (newVal) {
      this.hideVolumeField = false
      this.hideSubjectField = false
      this.hideGradeLevelField = false
      if ([materialTypes.Additional].includes(newVal)) {
        this.material.subject_id = null
        this.material.volume_id = null
        // this.material.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
      }
      if ([materialTypes.Activity].includes(newVal)) {
        this.material.subject_id = null
        // this.material.name = ''
        this.hideSubjectField = true
      }
      if ([materialTypes.Project, materialTypes.Supplementary].includes(newVal)) {
        this.material.grade_level_id = null
        this.material.subject_id = null
        this.material.volume_id = null
        // this.material.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
        this.hideGradeLevelField = true
      }
    },
    async 'material.grade_level_id' () {
      if (this.currentMaterial.grade_level_id !== this.material.grade_level_id) {
        await this.getSubjects()
        await this.getVolumes()
      }
    },
    'material.subject_id' (newVal) {
      if (this.subjects.length === 0) {
        return
      }
      if (this.material.subject_id !== null) {
        this.material.name = this.subjects.find((item) => item.id === this.material.subject_id).name
      } else {
        this.material.name = ''
      }

      if (!newVal) {
        this.name = ''
      }
    }
  },
  created () {
    this.subjectTextBooksUpdate = !utils.checkPermissions('subject-textbooks.update-any')
    this.subjectTextBooksDelete = utils.checkPermissions('subject-textbooks.delete')
    this.fetchAll()
  },
  methods: {
    listTypes,
    listVolumeTypes,
    async fetchAll () {
      this.types = listTypes()
      await this.getGradeLevelGroups()
      await this.getTeachingSystems()
      await this.getMaterial()
      await this.getSubjects()
      await this.getVolumes()
    },

    async getTeachingSystems () {
      try {
        const response = await this.$api.getTeachingSystems()
        this.systems = response
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os sistemas de ensino, tente novamente mais tarde.', color: 'red' })
      }
    },
    async getGradeLevelGroups () {
      try {
        const response = await this.$api.getGradeLevelGroups()
        this.gradelevelGroups = response
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os segmentos, tente novamente mais tarde.', color: 'red' })
      }
    },
    async getGradeLevel (id) {
      try {
        const response = await this.$api.getGradeLevels(id)
        this.gradelevels = response
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os anos, tente novamente mais tarde.', color: 'red' })
      }
    },
    async getSubjects () {
      try {
        const response = await this.$api.getSubjectsOfGradeLevel(this.material.grade_level_id, this.material.teaching_system_id)
        this.subjects = [
          ...response,
          {
            id: null,
            name: 'Outra'
          }
        ]
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter as matérias, tente novamente mais tarde.', color: 'red' })
      }
    },
    async getVolumes () {
      if (this.material.grade_level_id) {
        try {
          this.volumes = await this.$api.getVolumes(this.material.grade_level_id, this.material.teaching_system_id)
        } catch {
          this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os volumes, tente novamente mais tarde.', color: 'red' })
        }
      }
    },
    async getMaterial () {
      try {
        const response = await this.$api.GetMaterialTextBook(this.id)
        this.material = response
        if (response.grade_level_group_id) {
          this.getGradeLevel(response.grade_level_group_id)
        }
        if (response.grade_level_id && !response.grade_level_group_id) {
          const levelgroup = this.gradelevelGroups.find((item) => { return item.grade_levels.find((level) => level.id === response.grade_level_id) })
          this.material.grade_level_group_id = levelgroup.id
          this.getGradeLevel(levelgroup.id)
        }
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o material, tente novamente mais tarde.', color: 'red' })
      }
    },
    openUrl (url) {
      window.open(url)
    },
    validate () {
      return this.$refs.form.validate()
    },
    uploadMaterial () {
      this.waitingUpload = false
    },
    async deleteMaterial () {
      this.$dialog.confirm('Apagar material?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteMaterialTextBook(this.id)
            this.$store.dispatch('setSnackBar', { text: 'Material excluido com sucesso.' })
            this.$router.back()
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },
    async updateMaterial () {
      try {
        await this.$api.updateMaterialTextBook(this.id, this.material)
        this.$store.dispatch('setSnackBar', { text: 'Material atualizado com sucesso.' })
        this.fetchAll()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      }
    },
    statusName
  }
}
</script>
